<template>
  <div class="book">
    <LoadingBox v-if="isLoading" />

    <div
      v-if="!isLoading"
      class="book__cover"
      :style="{ backgroundImage: `url(${book.thumb_url})` }"
    ></div>

    <div class="container" v-if="!isLoading">
      <div class="row">
        <div class="col-lg-4 text-center text-lg-left mb-4 mb-lg-0">
          <picture class="book__img">
            <img :src="book.thumb_url" :alt="book.name" />
          </picture>
        </div>

        <div class="col-lg-8">
          <h1 class="book__name">{{ book.name }}</h1>
          <p class="book__description">{{ book.description }}</p>

          <div class="book__details">
            <div class="book__details__item" v-if="book.user">
              <span class="book__details__item__legend">Autor</span>
              <strong class="book__details__item__value">{{ book.user.name }}</strong>
            </div>

            <div class="book__details__item" v-if="book.year">
              <span class="book__details__item__legend">Ano</span>
              <strong class="book__details__item__value">{{ book.year }}</strong>
            </div>

            <div class="book__details__item" v-if="book.pages">
              <span class="book__details__item__legend">Páginas</span>
              <strong class="book__details__item__value">{{ book.pages }}</strong>
            </div>

            <div class="book__details__item" v-if="book.category">
              <span class="book__details__item__legend">Categoria</span>
              <strong class="book__details__item__value">{{ book.category.name }}</strong>
            </div>
          </div>

          <PrimaryButton @click="download" :disabled="isLoadingDownload">
            <span v-if="isLoadingDownload">Preparando o Download...</span>
            <span v-else>BAIXAR LIVRO AGORA</span>
          </PrimaryButton>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import { getBookDownloadUrl } from '@/api/book.api'
  import { mapGetters } from 'vuex'
  import PrimaryButton from '@/components/buttons/PrimaryButton'
  import LoadingBox from '@/components/layout/LoadingBox'

  export default {
    components: {
      PrimaryButton,
      LoadingBox,
    },

    props: {
      book: { type: Object, required: true }
    },

    data: () => ({
      isLoadingDownload: false,
    }),

    metaInfo () {
      return {
        title: this.book.id ? `Livro ${this.book.name} | CyberClass` : null
      }
    },

    computed: {
      ...mapGetters('user', ['isLogged', 'hasUserSubscriptionAccess']),

      isLoading () {
        return !this.book.id
      }
    },

    methods: {
      async download () {
        if (!this.hasUserSubscriptionAccess) {
          this.$gtm.trackEvent({ event: 'download_attempt', item_id: this.book.id, content_type: 'book' })
          return this.$router.push({ name: 'subscribe' })
        }

        this.isLoadingDownload = true

        const res = await getBookDownloadUrl(this.book.id)
        window.location.href = res.url
        this.$gtm.trackEvent({ event: 'download', item_id: this.book.id, content_type: 'book' })

        this.isLoadingDownload = false;
      }
    }
  }
</script>


<style scoped lang="scss">
  .book {
    position: relative;
    padding: 6.25rem 0;
    background: lighten(#000, 93%);
    overflow: hidden;

    &__cover {
      position: absolute;
      top: -30px;
      left: -30px;
      width: calc(100% + 60px);
      height: calc(100% + 60px);
      background-size: cover;
      background-position: center center;
      filter: blur(20px);

      &:after {
        content: '';
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background: rgba(#000, .25);
      }
    }

    &__img {
      display: inline-block;
      box-shadow: 3px 3px 30px 10px rgba(#fff, .1);
      border-radius: 5px;
      overflow: hidden;
      
      img { width: auto; max-width: 100% }

      @media (max-width: 992px) {
        img { max-width: 180px }
      }
    }

    &__name {
      font-family: 'Poppins';
      font-size: 1.75rem;
      font-weight: 700;
      line-height: 2rem;
      color: #fff;
      margin-bottom: 1.875rem;
    }

    &__description {
      color: #fff;
      font-size: 1.125rem;
    }

    &__details {
      color: #fff;
      margin: 1.875rem 0;
      max-width: 400px;

      &__item {
        display: flex;
        font-size: 1rem;
        

        &:not(:last-child) { margin-bottom: 3px }

        &__legend {
          width: 110px;
          margin-right: 3px;
        }

        &__legend,
        &__value {
          padding: 3px 10px ;
          background: rgba(#000, .3);
        }

        &__value { flex: 1 }
      }

      @media (max-width: 1024px) {
        &__item {
          align-items: flex-start;
          flex-direction: column;

          &__legend {
            width: auto;
          }

          &__value {
            width: 100%;
          }
        }
      }
    }
  }
</style>